import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Consider, however, this
                                                process
                                            </div>
                                            <p>Not too many years ago, receiving your salary involved taking
                                                a cheque to your bank in your lunch hour, waiting in a queue
                                                to pay it in and then waiting several days for it to
                                                clear.</p>
                                            <p>Now, most of our salaries are paid straight into our accounts
                                                overnight, and we have immediate access to the money.</p>
                                            <p>That‘s an improved process, enabled by advances in
                                                technology. You can bet, however, that when it was
                                                introduced there were those who warned it was bound to cause
                                                all manner of problems and, anyway, the old system worked
                                                well most of the time, so why the change?</p>
                                            <p>Now, of course, we don‘t give this process a thought until,
                                                very rarely, our salary doesn‘t arrive in our account, and
                                                we decide it‘s a rotten process which someone should do
                                                something about.</p>

                                            <div className="border_subtitle">Is there really a problem?
                                            </div>
                                            <p>‘Continuous improvement‘ is currently most quality managers
                                                ‘thing’. And it‘s a great concept – as long as it‘s kept in
                                                context. It‘s often just as productive or wise – if a system
                                                works and people find it easy to use – to leave it alone.
                                                There‘s no point in changing processes wholesale just for
                                                the sake of it. In fact, it can be unnecessarily stressful
                                                and disruptive for an entire organisation and everyone in
                                                it.</p>
                                            <p>Over time, processes will need revision and amendment as
                                                circumstances change but the key to smooth, easily
                                                assimilated change is to establish exactly what the problem
                                                or priority is – and fix that bit only.</p>
                                            <p>On the other hand, people can be possessive about certain
                                                processes (usually the ones who thought them up in the first
                                                place or others who‘ve got clever and cosy using them over
                                                the years!). You‘ll face less resistance if you make time
                                                and effort to win people over by involving them – give them
                                                a part to play and some ‘ownership’ of the change process
                                                itself.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad lightbgcenter"
                                                style={{paddingBottom: '5px'}}>
                                                <div className="border_subtitle">Remember, first
                                                    establish:
                                                </div>
                                                <ul className="greenbullet-list uiheading thought-list-pad">
                                                    <li><p>What is the problem?</p></li>
                                                    <li><p>Who is having problems?</p></li>
                                                    <li><p>Why do the problems occur?</p></li>
                                                    <li><p>When do the problems occur?</p></li>
                                                </ul>
                                                <div className="border_subtitle">Then, before deciding on
                                                    any changes, ask:
                                                </div>
                                                <ul className="greenbullet-list uiheading thought-list-pad">
                                                    <li><p>What options are there for fixing it?</p></li>
                                                    <li><p>What impact will any changes have?</p></li>
                                                </ul>
                                            </div>
                                            <div className="border_subtitle">Step 2</div>
                                            <p>Once you are clear about what ‘importance’ means to you, you
                                                are ready to prioritise tasks. List some of the tasks you‘ve
                                                been asked to complete in the last couple of weeks and rate
                                                the importance of each on a scale of 1 to 10, where 10 is
                                                ‘extremely important’.</p>
                                            <p>Next, consider why they are important. We think some tasks
                                                are important just because we do them automatically – but
                                                where do they fit on your scale? Again, you might need to
                                                think again about what you think is ‘important’.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad lightbgcenter">
                                                <p><span
                                                    className="green"><strong>Urgency:</strong></span> Now,
                                                    rate the urgency of each task on a scale of 1 to 5,
                                                    where 5 is ‘deadline imminent’. (Notice that the
                                                    ‘Urgency’ scale only goes up to 5 – because your first
                                                    consideration was to rate a task’s ‘Importance.’)</p>
                                                <div className="uiheading">
                                                    <p><span
                                                        className="green"><strong>Priority:</strong></span> Next,
                                                        add the ‘Importance’ and ‘Urgency’ scores. The tasks
                                                        with the highest scores are those that you should
                                                        focus on and do first.</p>
                                                </div>
                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}